import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { MailIcon, PhoneIcon, MapPinIcon, FacebookIcon, TwitterIcon, LinkedinIcon } from 'lucide-react';
import { TrustBadge } from './TrustBadge';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-28">
          {/* Company Info */}
          <div className="col-span-1" data-id="element-29">
            <Logo className="mb-4" data-id="element-30" />
            <p className="text-sm mb-4" data-id="element-31">
              Simple software for clearer, faster daily work.
            </p>

            <div className="space-y-2 text-sm" data-id="element-32">
              <div className="flex items-center gap-2" data-id="element-33">
                <MailIcon className="w-4 h-4" data-id="element-34" />
                <a href="mailto:srijangurung098@gmail.com" className="hover:text-emerald-400 transition-colors" data-id="element-35">
                  srijangurung098@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-2" data-id="element-36">
                <PhoneIcon className="w-4 h-4" data-id="element-37" />
                <span data-id="element-38">Phone: TBC</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-39">
                <MapPinIcon className="w-4 h-4" data-id="element-40" />
                <span data-id="element-41">Address: TBC</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-42">
            <h3 className="font-semibold text-white mb-4" data-id="element-43">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-44">
              <li data-id="element-45">
                <Link to="/" className="hover:text-emerald-400 transition-colors" data-id="element-46">
                  Home
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/service-details" className="hover:text-emerald-400 transition-colors" data-id="element-48">
                  Service Details
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/about" className="hover:text-emerald-400 transition-colors" data-id="element-50">
                  About Us
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/contact" className="hover:text-emerald-400 transition-colors" data-id="element-52">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/faqs" className="hover:text-emerald-400 transition-colors" data-id="element-54">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-55">
            <h3 className="font-semibold text-white mb-4" data-id="element-56">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-57">
              <li data-id="element-58">
                <Link to="/cancellation-policy" className="hover:text-emerald-400 transition-colors" data-id="element-59">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/refund-policy" className="hover:text-emerald-400 transition-colors" data-id="element-61">
                  Refund Policy
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/privacy-policy" className="hover:text-emerald-400 transition-colors" data-id="element-63">
                  Privacy & Cookie Policy
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/terms" className="hover:text-emerald-400 transition-colors" data-id="element-65">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div data-id="element-66">
            <h3 className="font-semibold text-white mb-4" data-id="element-67">Opening Hours</h3>
            <ul className="space-y-2 text-sm" data-id="element-68">
              <li data-id="element-69">Mon–Fri: 9am–5pm</li>
              <li data-id="element-70">Sat–Sun: Closed</li>
            </ul>

            <div className="flex gap-3 mt-6" data-id="element-71">
              <a href="#" className="w-8 h-8 bg-slate-800 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-colors" data-id="element-72">
                <FacebookIcon className="w-4 h-4" data-id="element-73" />
              </a>
              <a href="#" className="w-8 h-8 bg-slate-800 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-colors" data-id="element-74">
                <TwitterIcon className="w-4 h-4" data-id="element-75" />
              </a>
              <a href="#" className="w-8 h-8 bg-slate-800 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-colors" data-id="element-76">
                <LinkedinIcon className="w-4 h-4" data-id="element-77" />
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap gap-4 justify-center py-6 border-t border-slate-800" data-id="element-78">
          <TrustBadge icon="location" text="UK-Based" data-id="element-79" />
          <TrustBadge icon="payment" text="Secure Payments" data-id="element-80" />
          <TrustBadge icon="star" text="Trusted Service" data-id="element-81" />
          <TrustBadge icon="shield" text="Clear Pricing" data-id="element-82" />
        </div>

        {/* Copyright */}
        <div className="text-center text-sm pt-6 border-t border-slate-800" data-id="element-83">
          <p data-id="element-84">
            &copy; {new Date().getFullYear()} Domisafe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}